<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M8.2 19h9.6M6.4 16.9l8.5-8.5c.8-.8 2-.8 2.8 0l1.9 1.9c.8.8.8 2 0 2.8l-4.9 4.9c-.4.4-.9.6-1.4.6H9.2c-.5 0-1-.2-1.4-.6l-1.4-1.4c-.8-.8-.8-2 0-2.8Z"
      stroke="currentColor"
      stroke-width="2"
      stroke-linejoin="round"
      stroke-linecap="round"
    />
  </svg>
</template>

